export default __webpack_public_path__ + "static/media/venda-online.f66e1a14.png";